import APLoadingSpinner from "./APLoadingSpinner";

export default APLoadingSpinner;
